export default __webpack_public_path__ + "static/media/skipped1.ef341702.png";